<div class="container-fluid px-1 px-md-5 px-lg-1 px-xl-5 py-5 mx-auto" style="width: 50%">
  <div class="card card0 border-0">
    <div class="row d-flex">
      <div class="col-lg-12">
        <div class="card2 card border-0 px-4 py-5">
          <div class="row mb-4 px-3">
            <div class="card1 pb-5">
              <div class="row"> <h1 class="text-center">PATEMPO™</h1> </div>
            </div>
          </div>
          <div class="row px-3 mb-4">
            <div class="line"></div>
            <div class="line"></div>
          </div>

          <div *ngIf="showNotification">
            <div class="row px-3 mb-4" *ngIf="!showError">
              <small class="font-weight-bold">Your account has been Activated.<a class="text-danger " [routerLink]="['/login']"> Login</a></small>
            </div>
            <div class="row px-3 mb-4" *ngIf="showError">
              <small class="font-weight-bold">Account activation Failed.</small>
            </div>
          </div>

          <div class="row px-3 mb-4">
            <div class="line"></div>
            <div class="line"></div>
          </div>


          <div class="row px-3 mb-4">

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

